const PrimaryButton = ({ name,clickEvent}) => {
    return (
        <button className="btn btn-primary" onClick={clickEvent} >{ name }</button>
    )
}
export default PrimaryButton;